import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const CustomModal = ({ show, handleClose, modalTitle, inputFields, updateButton }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {inputFields.map((field, index) => (
            <Form.Group key={index}>
              <Form.Label>{field.label}</Form.Label>
              <Form.Control
                type={field.type}
                defaultValue={field.defaultValue}
                placeholder={field.placeholder}
                onChange={field.onChange}
                accept={field.accept} 
              />
            </Form.Group>
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant={updateButton.variant} onClick={updateButton.onClick}>
          {updateButton.text}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomModal;
